<template>
  <div class="writerBox clearfix">
    <chapterList
      v-if="islist"
      :isShowList="isShowList"
      @isOpenVo="isOpenVo"
    ></chapterList>
    <authorWrite
      v-if="islist"
      :mainInfo="mainInfo"
      @mainInfoChange="mainInfoChange"
      @checkSuccess="checkSuccess"
    ></authorWrite>
    <!-- 引入弹窗 -->
    <pop
      :isShowPop="isShowPop"
      :isShowPublish="isShowPublish"
      :isShowCreateVo="isShowCreateVo"
      :mainInfo="mainInfo"
      :bookname="bookname"
      @changeobj="changeobj"
      @isSuVo="isSuVo"
      @publishChapter="publishChapter"
    ></pop>
    <noneHint
      v-if="!islist"
      :noneListhint="noneListhint"
      @elseUrl="elseUrl"
    ></noneHint>
  </div>
</template>

<script>
import { getvolume, publishChapter } from "apiurl/author";
import { gettoll } from "utils/storage";
import { mapState } from "vuex";
export default {
  data() {
    return {
      isShowPop: false,
      islist: true,
      noneListhint: {
        msg: "作品还没创建哦~~",
        btnmsg: "创建作品",
        isbtn: true,
        istype: "book"
      },
      isShowCreateVo: false,
      isShowPublish: false,
      isShowList: false, // 是否展示书的章节列表
      mainInfo: {
        mainCount: 0, // 字数
        mainCon: "", // 正文
        chapterTitle: "", //章节标题
        authorCon: "", //作者的话,
        volumelist: [],
        typelist: [],
        chapterType: "1",
        rollvalue: "0",
        isSavebtn: true,
        isPubtn: true,
        pubTime: ""
      },
      saveChapter: {
        mainCon: "", // 正文
        chapterTitle: "", //章节标题
        authorCon: "" //作者的话,
      }
    };
  },
  created() {
    this.$nextTick(() => {
      if (this.$route.params.id > 0) {
        // 获取分卷
        this.getVolist();
        // 判断是否可选收费章节
        if (gettoll() === true) {
          this.mainInfo.typelist = [
            { value: "1", desc: "免费章节" },
            { value: "2", desc: "付费章节" },
            { value: "3", desc: "公告" }
          ];
        } else {
          this.mainInfo.typelist = [
            { value: "1", desc: "免费章节" },
            { value: "3", desc: "公告" }
          ];
        }
      } else {
        this.islist = false;
      }
    });
  },
  computed: mapState({
    bookname: state => state.author.bookName
  }),
  methods: {
    //   未创建作品
    elseUrl() {
      this.$router.push(`/authorManage/bookSetting/${this.$route.params.id}`);
    },
    // 打开vo弹窗
    isOpenVo(value) {
      this.isShowPop = value;
      this.isShowCreateVo = value;
    },
    // 关闭vo弹窗
    changeobj(obj) {
      this.isShowPop = obj.isShowPop;
      this.isShowPop = obj.isShowCreateVo;
    },
    // 获取分卷
    async getVolist() {
      let res = await getvolume(this.$route.params.id);
      if (res.success) {
        this.mainInfo.volumelist = res.data;
        if (this.mainInfo.volumelist.length > 0) {
          this.mainInfo.rollvalue = res.data[res.data.length - 1].id;
        }
        this.mainInfo.volumelist.unshift({ id: "0", name: "未分卷" });
      }
    },
    /* 获取添加卷是否成功 */
    isSuVo(isSuc) {
      if (isSuc.data) {
        this.getVolist();
        this.isShowCreateVo = false;
        this.isShowPop = false;
      }
    },
    /* ==清空 */
    mainInfoChange() {
      this.mainInfo.mainCount = 0;
      this.mainInfo.mainCon = "";
      this.mainInfo.authorCon = "";
      this.mainInfo.chapterType = "1";
      this.mainInfo.chapterTitle = "";
    },
    // 验证成功，打开发布弹窗
    checkSuccess() {
      this.isShowPublish = true;
      this.isShowPop = true;
    },
    // 发布新章节
    publishChapter(time) {
      var main = this.mainInfo;
      let data = {
        bookId: this.$route.params.id,
        additional: main.authorCon,
        content: main.mainCon,
        freeType: main.chapterType,
        name: main.chapterTitle,
        submitType: "publish",
        volumeId: main.rollvalue
      };
      if (time !== "") {
        data.time = time;
        data.submitType = "tpublish";
      }
      publishChapter(this.qs.stringify(data))
        .then(res => {
          if (res.success) {
            this.isShowPublish = false;
            this.isShowPop = false;
            this.mainInfo.mainCount = 0;
            this.mainInfo.mainCon = "";
            this.mainInfo.authorCon = "";
            this.mainInfo.chapterType = "1";
            this.mainInfo.chapterTitle = "";
            this.$message({
              message: "发布成功，并保存至已发布章节",
              type: "success"
            });
          }
        })
        .catch(() => {});
    }
  },
  beforeRouteLeave(to, from, next) {
    let $this = this;
    if (
      $this.saveChapter.chapterTitle == $this.mainInfo.chapterTitle &&
      $this.saveChapter.mainCon == $this.mainInfo.mainCon &&
      $this.saveChapter.authorCon == $this.mainInfo.authorCon
    ) {
      next();
    } else {
      let a = window.confirm("离开页面更改的内容将丢失！");
      if (a) {
        next();
      } else {
        next(false);
      }
    }
  },
  mounted() {
    let $this = this;
    window.onbeforeunload = function(e) {
      e = e || window.event;
      // 兼容IE8和Firefox 4之前的版本
      if (
        $this.saveChapter.chapterTitle == $this.mainInfo.chapterTitle &&
        $this.saveChapter.mainCon == $this.mainInfo.mainCon &&
        $this.saveChapter.authorCon == $this.mainInfo.authorCon
      ) {
        //console.log("tag", "可刷新");
      } else {
        if (e) {
          e.returnValue = "关闭提示";
        }
        // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
        return "关闭提示";
      }
    };
  },
  beforeDestroy() {
    /*  if(this.mainInfo.mainCon!=="" || this.mainInfo.chapterTitle!==""){
                                           
                                                 } */
  }
};
</script>
<style lang="stylus" scoped>
.writerBox
    width 100%
</style>
